module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_iter-step.js
// module id = 143
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11